import TableLoading from "../../../Components/Loader/TableLoading";
import SVG from "../../../Components/SVG";
import Table from "../../../Components/Table/Table";
import StatusColorful from "../../../Components/Table/Components/StatusColorful";

const displayOptionalValue = (value) =>
  value === null ||
  value === undefined ||
  String(value).trim() === "" ||
  String(value).trim() === "-"
    ? "ندارد"
    : value;

export default function TransactionsTable({
  rows,
  accLoading,
  showEmptyState,
}) {
  return (
    <div className="w-full flex flex-col gap-5">
      <Table
        columns={[
          { key: "uuid", label: "کد تراکنش" },
          {
            key: "transactionType",
            label: "نوع تراکنش",
            render: (value) =>
              value === "deposit" ? (
                <div className="flex items-end justify-center gap-2.5 text-zi-text-light dark:text-zi-text-dark">
                  <SVG name="deposit" />
                  <span>واریز</span>
                </div>
              ) : value === "withdraw" ? (
                <div className="flex items-end justify-center gap-2.5 text-zi-text-light dark:text-zi-text-dark">
                  <SVG name="withdraw" classname="stroke-[#D71F1F]" />
                  <span>برداشت</span>
                </div>
              ) : (
                ""
              ),
          },
          { key: "paymentType", label: "روش پرداخت" },
          { key: "requestDate", label: "تاریخ درخواست" },
          { key: "volume", label: "مبلغ" },
          {
            key: "accountID",
            label: "کد حساب",
            render: displayOptionalValue,
          },
          {
            key: "doneDate",
            label: "تاریخ تکمیل",
            render: displayOptionalValue,
          },
          {
            key: "status",
            label: "وضعیت",
            render: (value) =>
              value === "done" ? (
                <StatusColorful
                  SVGName="tick"
                  text="تکمیل شده"
                  className="w-24"
                  color="green"
                />
              ) : value === "stall" ? (
                <StatusColorful
                  SVGName="stall"
                  text="در انتظار"
                  className="w-24"
                  color="yellow"
                />
              ) : value === "failed" ? (
                <StatusColorful
                  SVGName="failed"
                  text="رد شده"
                  className="w-24"
                  color="red"
                />
              ) : (
                ""
              ),
          },
        ]}
        data={rows}
      />

      {accLoading && (
        <div className="w-full flex justify-center items-center gap-2">
          <p className="text-[#808080]">در حال بارگذاری</p>
          <TableLoading className="text-[#808080]" />
        </div>
      )}
      {showEmptyState && (
        <div className="w-full flex justify-center items-center flex-col gap-5">
          <p className="text-zi-text-light dark:text-zi-text-dark text-sm sm:text-base">
            موردی برای نمایش وجود ندارد
          </p>
          <SVG name="noData" classname="w-24 fill-cyan-500" />
        </div>
      )}
    </div>
  );
}
